export default __webpack_public_path__ + "static/media/tanks.20315698.svg";